
    <div [formGroup]="formGroup">
      <ng-container #dynamicComponent></ng-container>
    </div>
  